import { capitalizeWords, combineWordsWithAnd } from './string';

export const omit = (object, key) => {
  const copy = { ...object };
  const keys = typeof key === 'string' ? [key] : key;
  keys.forEach((k) => {
    delete copy[k];
  });
  return copy;
};

export const listRequirements = (reqs) => {
  let reqList = '';
  if (typeof reqs === 'object') {
    const reqArr = [];
    const primaryKeys = Object.keys(reqs);
    if (primaryKeys.length > 0) {
      primaryKeys.forEach((primaryKey) => {
        const subKeys = Object.keys(reqs[primaryKey]);
        if (subKeys.length > 0) {
          subKeys.forEach((subKey) => {
            if (reqs[primaryKey][subKey]) {
              if (typeof reqs[primaryKey][subKey] === 'object') {
                const subKeysArr = Object.keys(reqs[primaryKey][subKey]).filter(
                  (key) => reqs[primaryKey][subKey][key]
                );
                if (subKeysArr.length > 0) {
                  subKey = `${capitalizeWords(subKey)} ( ${combineWordsWithAnd(
                    subKeysArr
                  )} )`;
                } else {
                  subKey = false;
                }
              } else {
                subKey = capitalizeWords(subKey);
              }
              reqArr.push(subKey);
            }
          });
        }
      });
    }
    if (reqArr.length > 0) {
      reqList = reqArr.filter((sub) => sub).join(', ');
    }
  }
  return reqList;
};

export const listSubscription = (instance, type = 'subscription') => {
  let subscription = [];

  if (type in instance) {
    subscription = Object.keys(instance[type])
      .filter((key) => instance[type][key])
      .map((sub) => {
        if (typeof instance[type][sub] === 'object') {
          const subKeys = Object.keys(instance[type][sub]).filter(
            (key) => instance[type][sub][key]
          );
          if (subKeys.length > 0) {
            sub = `${capitalizeWords(sub)} ( ${combineWordsWithAnd(subKeys)} )`;
          } else {
            sub = false;
          }
        } else {
          sub = capitalizeWords(sub);
        }
        return sub;
      })
      .filter((sub) => sub);
  }

  return subscription;
};
